export interface Movie {
  id: string;
  title: string;
  type: "电影" | "电视剧";
  year: number;
  region: string;
  rating: number;
  cover: string;
  heroImage?: string;
  synopsis: string;
  description: string[];
  director: string;
  cast: string[];
  tags: string[];
  specialIds: string[];
  featured?: boolean;
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "雨后花园",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    rating: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20poster%20artwork%20of%20a%20blooming%20lilac%20garden%20after%20rain%2C%20glistening%20wet%20petals%20and%20soft%20mist%2C%20two%20distant%20silhouettes%20sharing%20an%20umbrella%20on%20a%20winding%20stone%20path%2C%20violet%20and%20blush%20pink%20pastel%20palette%2C%20romantic%20melancholic%20mood%2C%20gentle%20film%20grain%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20soft%20lighting&width=600&height=900&seq=baihe-mv-01&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20hero%20still%20of%20a%20rain%20washed%20lilac%20garden%20at%20twilight%2C%20luminous%20wet%20blossoms%20and%20drifting%20mist%2C%20two%20figures%20walking%20a%20distant%20path%20hand%20in%20hand%2C%20violet%20and%20blush%20pink%20gradient%20sky%2C%20dreamy%20romantic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20soft%20film%20grain%2C%20elegant%20editorial%20cinematography%2C%20high%20detail%2C%20dark%20negative%20space%20on%20the%20left%20for%20text&width=1920&height=1080&seq=baihe-hero-01&orientation=landscape",
    synopsis:
      "一场突如其来的雨后，园艺师林知夏与久别重逢的旧友在自家花园里重新拾起一段未说出口的心事。",
    description: [
      "南方小城的雨季总是不期而至。园艺师林知夏守着母亲留下的一座小花园，日子过得安静而缓慢。直到一个湿漉漉的傍晚，撑伞而来的旅人苏晚，站在了她花园的门口。",
      "两人曾是高中时代无话不谈的好友，却在毕业那年因为一场误会各自远行。多年后的重逢，让那些被雨水冲淡的记忆再次泛起涟漪。",
      "影片用大量细腻的空镜与克制的对白，讲述了两段人生如何在雨后的花园里慢慢靠近。所谓成长，不过是学会把没说出口的话，终于说给对方听。",
    ],
    director: "沈梧桐",
    cast: ["周与安", "林晓棠", "苏澈"],
    tags: ["治愈", "重逢", "慢热"],
    specialIds: ["s1"],
    featured: true,
  },
  {
    id: "2",
    title: "追光少女",
    type: "电视剧",
    year: 2024,
    region: "日本",
    rating: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20poster%20artwork%20of%20a%20sunlit%20rooftop%20at%20golden%20hour%2C%20a%20girl%20reaching%20toward%20warm%20light%20beams%2C%20lavender%20and%20coral%20pastel%20sky%2C%20youthful%20hopeful%20romance%20mood%2C%20soft%20focus%20background%2C%20delicate%20film%20grain%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20gentle%20lighting&width=600&height=900&seq=baihe-mv-02&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20hero%20still%20of%20a%20sunlit%20rooftop%20garden%20at%20golden%20hour%2C%20warm%20light%20beams%20and%20floating%20dust%20motes%2C%20a%20lone%20figure%20leaning%20on%20the%20railing%20in%20the%20distance%2C%20lavender%20and%20peach%20gradient%20sky%2C%20hopeful%20romantic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20gentle%20film%20grain%2C%20refined%20editorial%20cinematography%2C%20high%20detail%2C%20spacious%20dark%20left%20area%20for%20typography&width=1920&height=1080&seq=baihe-hero-02&orientation=landscape",
    synopsis:
      "立志成为灯光师的高中生绫濑光，与转学生作曲家朝比奈遥在校园广播站相遇，用声音与光影拼凑出一段只属于她们的青春。",
    description: [
      "绫濑光从小就对“光”着迷。她相信只要把灯光打对，再黯淡的故事也能被照亮。转入这所临海高中的第一天，她就在校园广播站的杂物间里，撞见了抱着吉他写歌的朝比奈遥。",
      "一个负责光，一个负责声。两个原本平行的女孩，因为一场校园文化祭的舞台剧走到了一起。她们在放学后的天台排练，在深夜的广播站里交换歌单，也在彼此的沉默里读懂了对方的心事。",
      "剧集以单元式的结构展开，用十二集讲述了一整个夏天。它不急于定义关系，而是让情感像光一样，一寸一寸地漫进观众心里。",
    ],
    director: "高桥凛",
    cast: ["小野寺瞳", "藤井结衣", "佐仓真白"],
    tags: ["青春", "校园", "音乐"],
    specialIds: ["s2", "s4"],
    featured: true,
  },
  {
    id: "3",
    title: "她的周日下午",
    type: "电影",
    year: 2022,
    region: "中国台湾",
    rating: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20cinematic%20poster%20artwork%20of%20a%20cozy%20apartment%20window%20seat%20on%20a%20lazy%20Sunday%20afternoon%2C%20warm%20sunlight%20through%20sheer%20curtains%2C%20two%20teacups%20on%20a%20wooden%20sill%2C%20mauve%20and%20cream%20pastel%20palette%2C%20quiet%20intimate%20romance%20mood%2C%20soft%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20soft%20lighting&width=600&height=900&seq=baihe-mv-03&orientation=portrait",
    synopsis:
      "两个习惯独处的女人，因为每周日下午同一家书店的邂逅，慢慢把各自安静的生活拼成了一张共同的、慵懒的拼图。",
    description: [
      "书店店员何予晴的生活规整得像排好的书脊。每个周日下午三点，她会给自己泡一杯红茶，坐在靠窗的位置读一本旧书。",
      "直到某个周日，一位总戴着浅色围巾的客人坐到了她对面。两人从最初礼貌的点头，到后来自然而然地共享一张桌子、一本书、一个下午。",
      "电影几乎没有戏剧性的冲突，它只是安静地记录了两个成年人如何笨拙而温柔地靠近。有些爱情不是轰轰烈烈，而是刚好在对的时间，遇见了愿意陪你浪费时间的人。",
    ],
    director: "陈苡宁",
    cast: ["许知晴", "罗佩珊"],
    tags: ["细腻", "日常", "慢节奏"],
    specialIds: ["s3"],
  },
  {
    id: "4",
    title: "蔷薇契约",
    type: "电视剧",
    year: 2023,
    region: "韩国",
    rating: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20of%20climbing%20roses%20over%20an%20old%20brick%20wall%2C%20deep%20rose%20and%20violet%20tones%2C%20an%20elegant%20envelope%20sealed%20with%20wax%20resting%20on%20a%20stone%20ledge%2C%20mysterious%20romantic%20mood%2C%20subtle%20film%20grain%2C%20polished%20editorial%20composition%2C%20high%20detail%2C%20dramatic%20soft%20lighting&width=600&height=900&seq=baihe-mv-04&orientation=portrait",
    synopsis:
      "为了守住祖传的蔷薇庄园，千金韩瑞妍与园艺设计师签署了一纸“契约”，却在朝夕相处中，把交易变成了心动。",
    description: [
      "蔷薇庄园是韩瑞妍童年全部的回忆，也是她如今唯一的筹码。为了阻止家族将庄园出售，她必须在三个月内让它重新开花盈利。",
      "园艺设计师尹涩琪的到来，像是给这座沉寂的庄园注入了一剂强心针。她冷静、专业，谈条件时毫不留情，却在每一次修剪枝叶时露出难得的温柔。",
      "两人从针锋相对的合伙人，到并肩看庄园第一朵蔷薇绽放。所谓契约，不过是两个人给彼此一个靠近的借口。",
    ],
    director: "朴宥真",
    cast: ["韩瑞妍", "尹涩琪", "郑度勋"],
    tags: ["都市", "契约", "成长"],
    specialIds: ["s3"],
  },
  {
    id: "5",
    title: "海风里的信",
    type: "电影",
    year: 2024,
    region: "中国大陆",
    rating: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20windswept%20seaside%20at%20dusk%2C%20sea%20foam%20and%20tall%20dune%20grass%2C%20a%20folded%20letter%20carried%20by%20the%20breeze%2C%20muted%20violet%20and%20dusty%20pink%20sunset%20tones%2C%20wistful%20longing%20mood%2C%20gentle%20film%20grain%2C%20airy%20editorial%20composition%2C%20high%20detail%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=baihe-mv-05&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20hero%20still%20of%20a%20windswept%20seaside%20at%20dusk%2C%20tall%20dune%20grass%20and%20rolling%20waves%20in%20soft%20focus%2C%20a%20small%20figure%20on%20the%20shoreline%2C%20muted%20violet%20and%20dusty%20rose%20sunset%20sky%2C%20wistful%20romantic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20tasteful%20editorial%20cinematography%2C%20high%20detail%2C%20dark%20open%20sky%20area%20on%20the%20left%20for%20text&width=1920&height=1080&seq=baihe-hero-03&orientation=landscape",
    synopsis:
      "灯塔守护者的女儿收集了十年无处投递的信，直到一位陌生的海洋研究员，读懂了那些信里藏着的名字。",
    description: [
      "在海边小镇长大的江屿，有一个无人知道的习惯：她把所有说不出口的话，都写成信，放进灯塔下的旧铁盒。十年间，铁盒里积满了几百封没有收件人的信。",
      "海洋研究员岑渺的到来打破了小镇的平静。她为调查海岸生态而来，却在借住灯塔旁的旧屋时，无意间发现了那个生锈的铁盒。",
      "一封封读下来，她发现所有的信都写给同一个从未被点名的“你”。而那个“你”，或许一直就在她每天清晨散步会经过的地方。",
    ],
    director: "谢亦舟",
    cast: ["江晚澄", "周念禾", "许屿舟"],
    tags: ["文艺", "守望", "海边"],
    specialIds: ["s1", "s4"],
    featured: true,
  },
  {
    id: "6",
    title: "第二杯半价",
    type: "电视剧",
    year: 2022,
    region: "中国大陆",
    rating: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20cinematic%20poster%20artwork%20of%20a%20warm%20cozy%20cafe%20counter%2C%20two%20coffee%20cups%20side%20by%20side%20with%20latte%20art%2C%20dusty%20pink%20and%20soft%20lavender%20tones%2C%20cheerful%20sweet%20romance%20mood%2C%20blurred%20pendant%20light%20bokeh%20background%2C%20light%20film%20grain%2C%20clean%20editorial%20composition%2C%20high%20detail%2C%20warm%20soft%20lighting&width=600&height=900&seq=baihe-mv-06&orientation=portrait",
    synopsis:
      "咖啡店老板与每天只点“第二杯半价”套餐的常客，用一张又一张小票，写下了最笨拙也最甜的告白。",
    description: [
      "“第二杯半价”本来是店里的促销，却成了常客陆时雨每天来报到的理由。她总说，一个人喝不下两杯，所以老板得出面解决。",
      "咖啡店老板程念念心知肚明，却乐得配合。两人之间的默契，就藏在每天固定的一杯美式、一杯拿铁和一张手写小票里。",
      "剧集用轻松明快的节奏，讲述了一段发生在市井烟火里的甜系恋爱。原来最动人的情话，可能只是一句“今天也给你留了位置”。",
    ],
    director: "何鹿鸣",
    cast: ["程念", "陆时雨", "高聆"],
    tags: ["甜宠", "都市", "轻松"],
    specialIds: ["s2"],
  },
  {
    id: "7",
    title: "月光与猫",
    type: "电影",
    year: 2021,
    region: "日本",
    rating: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20poster%20artwork%20of%20a%20moonlit%20balcony%20with%20climbing%20vines%2C%20a%20sleeping%20cat%20on%20the%20railing%2C%20silvery%20violet%20and%20pale%20blue%20pink%20tones%2C%20tender%20quiet%20romance%20mood%2C%20soft%20night%20bokeh%20background%2C%20delicate%20film%20grain%2C%20elegant%20editorial%20composition%2C%20high%20detail%2C%20gentle%20moonlit%20lighting&width=600&height=900&seq=baihe-mv-07&orientation=portrait",
    synopsis:
      "独居的插画师与她楼上那位总在深夜弹琴的邻居，因为一只总在天台出没的流浪猫，慢慢走近了彼此的世界。",
    description: [
      "插画师森野栞习惯在深夜作画，而楼上总会准时传来断断续续的钢琴声。起初她只觉得吵，后来却发现，没有琴声的夜晚，她反而睡不着了。",
      "一只不肯被人抱的流浪猫，成了两人之间唯一的信使。它白天在她窗台晒太阳，夜里又跑到楼上的露台打盹。",
      "一部关于孤独与陪伴的电影。它告诉我们，有些人不需要说很多话，只要知道楼上/楼下有另一个醒着的灵魂，就足够勇敢。",
    ],
    director: "中村悠",
    cast: ["森野栞", "白河遥"],
    tags: ["治愈", "日常", "音乐"],
    specialIds: ["s1"],
  },
  {
    id: "8",
    title: "深巷面包店",
    type: "电视剧",
    year: 2024,
    region: "中国台湾",
    rating: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20cinematic%20poster%20artwork%20of%20a%20small%20bakery%20in%20a%20quiet%20alley%20at%20dawn%2C%20warm%20bread%20and%20pastries%20in%20the%20window%2C%20crates%20of%20fresh%20flowers%2C%20soft%20mauve%20and%20buttery%20cream%20tones%2C%20heartwarming%20romance%20mood%2C%20subtle%20film%20grain%2C%20charming%20editorial%20composition%2C%20high%20detail%2C%20warm%20soft%20lighting&width=600&height=900&seq=baihe-mv-08&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20hero%20still%20of%20a%20warm%20bakery%20alley%20at%20dawn%2C%20hanging%20lanterns%20and%20steam%20from%20fresh%20bread%20in%20soft%20focus%2C%20a%20distant%20figure%20in%20an%20apron%2C%20soft%20mauve%20and%20cream%20morning%20tones%2C%20cozy%20romantic%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20gentle%20film%20grain%2C%20charming%20editorial%20cinematography%2C%20high%20detail%2C%20dark%20shaded%20left%20side%20for%20overlay%20text&width=1920&height=1080&seq=baihe-hero-04&orientation=landscape",
    synopsis:
      "接手外婆面包店的女孩，与每天清晨来买第一炉可颂的邮差，在巷口的烟火气里，烤出了一段缓慢升温的感情。",
    description: [
      "叶知遥辞掉大城市的工作，回到老家接手外婆留下的小面包店。巷子很旧，生意很淡，但她想守住炉子里那点熟悉的味道。",
      "每天清晨六点，邮差莫雨棠都会准时出现，买走第一炉出炉的可颂，然后骑着车消失在巷口。她们之间最初的对话，不过是“今天也是老样子吗”。",
      "随着四季更替，两人从陌生到熟悉，从沉默到无话不谈。一家面包店，一条老巷子，装下了两个普通女孩最踏实的幸福。",
    ],
    director: "林砚书",
    cast: ["叶知遥", "莫雨棠", "简安"],
    tags: ["治愈", "烟火气", "成长"],
    specialIds: ["s2", "s4"],
    featured: true,
  },
  {
    id: "9",
    title: "星期六的蓝调",
    type: "电影",
    year: 2023,
    region: "法国",
    rating: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20poster%20artwork%20of%20a%20hazy%20Saturday%20evening%20city%20boulevard%2C%20neon%20reflections%20on%20wet%20pavement%2C%20muted%20violet%20and%20smoky%20rose%20tones%2C%20lingering%20romantic%20melancholic%20mood%2C%20cinematic%20film%20grain%2C%20stylish%20editorial%20composition%2C%20high%20detail%2C%20atmospheric%20soft%20lighting&width=600&height=900&seq=baihe-mv-09&orientation=portrait",
    synopsis:
      "一位爵士酒吧的钢琴手，每个星期六都会为同一位坐在角落的听众演奏，直到有一天，那位听众没有再出现。",
    description: [
      "巴黎左岸的爵士酒吧里，钢琴手爱丽丝有一个人尽皆知的秘密：每个星期六的最后一首曲子，她都是弹给角落那张固定桌子的人。",
      "那位客人从不点单，只安静地听完最后一曲再离开。两人始终没有正式说过一句话，却用音乐完成了几百次只有彼此听得懂的对话。",
      "当某个星期六，那张桌子第一次空着，爱丽丝才意识到，有些告别来得比想象中更早。电影用音乐与沉默，讲述了一段无疾而终却无比真挚的暗恋。",
    ],
    director: "Camille Roy",
    cast: ["Alice Moreau", "Juliette Blanc"],
    tags: ["文艺", "音乐", "暗恋"],
    specialIds: ["s3"],
  },
  {
    id: "10",
    title: "未寄出的夏天",
    type: "电视剧",
    year: 2021,
    region: "泰国",
    rating: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=Sun%20drenched%20cinematic%20poster%20artwork%20of%20a%20tropical%20summer%20shoreline%20with%20palm%20shadows%2C%20an%20unopened%20letter%20on%20warm%20sand%2C%20peach%20pink%20and%20soft%20lilac%20tones%2C%20nostalgic%20bittersweet%20romance%20mood%2C%20warm%20film%20grain%2C%20breezy%20editorial%20composition%2C%20high%20detail%2C%20golden%20soft%20lighting&width=600&height=900&seq=baihe-mv-10&orientation=portrait",
    synopsis:
      "毕业那年的最后一个夏天，两个女孩约好一起去海边看日出，却因为一封信，让这场约定迟到了整整五年。",
    description: [
      "高中最后一个夏天，班长苹婉和转学生楠决定在毕业前完成一个心愿清单：看一次海边日出、拍一组合照、对最想说的人说一句真心话。",
      "然而就在出发前一晚，一封没有署名的信打乱了所有计划。苹婉没有出现，楠独自在海边等到了天亮。",
      "五年后，两人在一个意想不到的地方重逢。那个未完成的夏天，终于有了被重新讲述的机会。",
    ],
    director: "Napat Sri",
    cast: ["苹婉", "楠", "Tle"],
    tags: ["青春", "遗憾", "重逢"],
    specialIds: ["s3"],
  },
  {
    id: "11",
    title: "玻璃花房",
    type: "电影",
    year: 2024,
    region: "韩国",
    rating: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20cinematic%20poster%20artwork%20of%20a%20luminous%20glass%20greenhouse%20filled%20with%20blooming%20flowers%2C%20soft%20light%20refracting%20through%20glass%20panels%2C%20mauve%20and%20pearl%20pink%20tones%2C%20serene%20romantic%20mood%2C%20delicate%20film%20grain%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20luminous%20soft%20lighting&width=600&height=900&seq=baihe-mv-11&orientation=portrait",
    synopsis:
      "植物学家与她曾经的学生，在一座即将被拆除的玻璃花房里，重新面对那场未完成、也未曾真正结束的告别。",
    description: [
      "十年前的玻璃花房，是老师车秀雅和她的学生韩世京之间心照不宣的避风港。那里种满了两人一起培育的稀有兰花。",
      "如今花房因城市规划面临拆除，已成为知名植物学家的韩世京回到了这座城市。她此行的目的，是见老师最后一面，也是问清十年前那个没有答案的问题。",
      "电影以花房的四时变化为线索，用极致的影像美学，讲述了一段跨越十年的克制情感。有些爱意像兰花，需要漫长的等待，才能开出一朵。",
    ],
    director: "文素妍",
    cast: ["车秀雅", "韩世京", "李道允"],
    tags: ["文艺", "师生", "美学"],
    specialIds: ["s1", "s4"],
    featured: true,
  },
  {
    id: "12",
    title: "闺蜜以上",
    type: "电视剧",
    year: 2023,
    region: "中国大陆",
    rating: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cinematic%20poster%20artwork%20of%20a%20playful%20city%20rooftop%20picnic%20at%20sunset%2C%20string%20lights%20and%20blankets%2C%20coral%20pink%20and%20lavender%20tones%2C%20cheerful%20flirtatious%20romance%20mood%2C%20airy%20film%20grain%2C%20fresh%20editorial%20composition%2C%20high%20detail%2C%20warm%20happy%20lighting&width=600&height=900&seq=baihe-mv-12&orientation=portrait",
    synopsis:
      "合租三年的两位好友，在一次“假装情侣”的乌龙之后，开始重新审视这段“闺蜜以上”的关系。",
    description: [
      "周以宁和倪好是合租三年的室友，也是彼此最熟悉的朋友。她们共享一个冰箱、一份外卖账号，和全部的秘密。",
      "直到一场同学聚会上的乌龙，让两人不得不临时“扮演”情侣。演着演着，她们才发现，原来那些习以为常的照顾，早就超出了友谊的范围。",
      "一部轻松又不失真诚的都市剧。它讨论的是：当友情遇到爱情，我们该如何诚实地面对自己的心。",
    ],
    director: "何鹿鸣",
    cast: ["周以宁", "倪好"],
    tags: ["都市", "甜宠", "同居"],
    specialIds: ["s2"],
  },
];